module.exports = __webpack_public_path__ + "img/USD-CHF.2912bdae.png";